import { IconButton, Theme } from '@mui/material';
import React from 'react';
import Colors from '../../utils/color';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  iconButtonClass: {
    width: '40px',
    height: '100%',
    padding: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    margin: '4px !important',
  },
  iconComponentClass: {
    width: '100% !important',
    height: (props: any) => (props.isActive ? '50px !important' : '40px !important'),
    padding: (props: any) => (props.isActive ? '4px' : '10px'),
    borderRadius: '4px',
  },
}));

export interface IVisualIndicator {
  IconComponent: React.ElementType;
  onClick?: (event?: any) => void;
  isActive?: boolean;
  customizedColor?: string;
  id?: string;
}

const VisualIndicator = (props: IVisualIndicator) => {
  const { iconButtonClass, iconComponentClass } = useStyles(props);
  const { onClick, IconComponent, id, customizedColor, isActive } = props;

  return (
    <IconButton id={id} className={iconButtonClass} onClick={onClick}>
      <IconComponent fontSize="small" className={iconComponentClass} sx={{ color: customizedColor ? customizedColor : isActive ? Colors.brightGreen : Colors.dim }} />
    </IconButton>
  );
};

export default VisualIndicator;
